import React from 'react';

import { Link as GatsbyLink } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

import { trackCTA, withRef } from '../utils/track';

/**
 * Shared link component.
 *
 * Pass `track="hero"` to record the click as a CTA in Umami. The value is the
 * location name used in three places — the event property, the virtual path
 * (/cta/hero/) and the `?ref=` on outbound links to our own apps — so keep it
 * short, lowercase and stable. Renaming it breaks historical comparisons.
 *
 * `?ref=` is what lets the register page attribute a signup attempt back to a
 * specific button. It is added only for links to dashboard.polypane.app, and
 * never overrides a `ref` already present in the URL.
 *
 * `trackLabel` is optional and defaults to the link's text content when that is
 * a plain string.
 */
const Link = ({ children, to, activeClassName, getProps, track, trackLabel, onClick, ...other }) => {
  // @TODO this is a hack to fix menu closing for pages that are secretly the same.
  const internal = /^\/(?!\/)/.test(to);
  const href = track ? withRef(to, track) : to;

  const handleClick = (event) => {
    if (track) {
      trackCTA(track, {
        label: trackLabel || (typeof children === 'string' ? children : undefined),
        destination: href,
      });
    }

    if (onClick) onClick(event);
  };

  if (internal) {
    return (
      <GatsbyLink to={href} activeClassName={activeClassName} onClick={handleClick} {...other}>
        {children}
      </GatsbyLink>
    );
  }
  return (
    <OutboundLink href={href} onClick={handleClick} {...other}>
      {children}
    </OutboundLink>
  );
};

export default Link;
